<i18n>
{
  "en": {
    "periodLoadingError": "Error updating period data",
    "errorRecommendations": "There was an error generating recommendations",
    "stillPredicting": "Some predictions are still ongoing, please, try again later",
    "noPricing": "Price optimizer isn't available for this period. If you have any questions, ask Support."
  },
  "es": {
    "periodLoadingError": "Error actualizando datos de periodo",
    "errorRecommendations": "Hubo algún error en la generación de recomendaciones",
    "stillPredicting": "Aún se están generando datos de predicciones, por favor, inténtelo más tarde",
    "noPricing": "No está disponible el optimizador de precios para este periodo. Si tiene dudas, consulte a Soporte."
  }
}
</i18n>

<template>
  <router-view v-bind="{recommendationModalVisible, generationState}"/>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { checkPeriodMixin } from '@pointOfSale/mixins';
import { createInfoNotification } from '@ulibs/unnotificationsqueue';
import {
  MapActions, MapGetters, Mixins, Name
} from '@/apps/core/helpers/decorators';

@Component
@Mixins([checkPeriodMixin('price', ['demand', 'menu'])])
@MapGetters(['isLoading', 'predictionPeriodList'])
export default class PriceOptimizer extends Vue {
  @Name 'price-optimizer'

  async created() {
    if (!await this.checkPreconditions()) {
      this.addNotification(createInfoNotification(this.$t('stillPredicting')));
      this.allowRouteExitWithoutConfirmation = true;
      const routeParams = { ...this.$route.params, allowRouteExitWithoutConfirmation: true };
      await this.$router.push({ name: 'optimizer', params: routeParams });
    }
    await this.reloadPeriod();
    await this.getOptimizerData();
    if (this.disabledPricePrediction) {
      this.addNotification(createInfoNotification(this.$t('noPricing')));
      this.allowRouteExitWithoutConfirmation = true;
      await this.$router.push({ name: 'optimizer' });
    }
  }

  get selectedPeriod() {
    return this.predictionPeriodList.find((period) => period.guid === this.$route.params.periodGuid);
  }

  get disabledPricePrediction() {
    return this.selectedPeriod?.hasActiveExperiments;
  }

  @MapActions(['addNotification', 'productPriceRecommendationsRequest', 'setLoading', 'indexedProductPriceRequest'])
  async getOptimizerData() {
    try {
      await this.setLoading(1);
      await this.productPriceRecommendationsRequest(this.$route.params.periodGuid);
      await this.indexedProductPriceRequest(this.$route.params.periodGuid);
      await this.setLoading(-1);
    } catch (e) {
      if (this.isLoading) {
        this.setLoading(-1);
      }
    }
  }

  @Watch('$route')
  onRouteChange(to, from) {
    if (to.params.periodGuid !== from.params.periodGuid) {
      this.getOptimizerData();
    }
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) {
      this.$router.push({ name: 'restaurant-management' });
    }
  }

  beforeRouteLeave(to, from, next) {
    if (this.waiter) this.waiter.forceClear();
    if (this.isLoading) {
      this.setLoading(-1);
    }
    next();
  }
}
</script>
